import { inject } from '@angular/core';
import { ResolveFn, Router } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { ApiRequestService } from '@core/services/api-request.service';
import { TosterService } from '@core/services/toster.service';
import { AppData } from '@core/services/app-data.service';
import { UserService } from '@core/auth/user/user.service';
import { AuthCoreService } from '@page/auth/auth-core.service';
import { config } from '@core/services/request-url.service';
import { environment } from 'src/environments/environment';
import { LocationService } from '@core/location-required/location-required.service';
import { DashboardService } from '@page/dashboard/helper/dashboard-service';
import { PermissionService } from '@core/auth/permission/permission.service';

export const verifyTokenResolver: ResolveFn<Promise<boolean>> = async (route) => {
  const apiRequestService = inject(ApiRequestService);
  const toater = inject(TosterService);
  const appData = inject(AppData);
  const _LocationService = inject(LocationService);
  const userService = inject(UserService);
  const _PermissionService = inject(PermissionService);
  const _DashboardService = inject(DashboardService);
  const router = inject(Router);

  const token = route.queryParamMap.get('token') ?? '';
  const method = route.queryParamMap.get('method') ?? '';
  const id = route.queryParamMap.get('id') ?? '';
  const latLang = _LocationService.coords();

  if (!token || !method) {
    toater.showError('Invalid or missing verification parameters.');
    router.navigate(['/login']);
    return false;
  }

  const data = {
    token,
    method,
    row: id,
    latitude: latLang?.latitude ?? '',
    longitude: latLang?.longitude ?? '',
    version: environment.version,
  };

  try {
    const res: any = await firstValueFrom(apiRequestService.postdata(data, config['validate']));
    if (res?.statuscode === 200) {
      userService.setLoginData(res);
      appData.setUserDetails(res);
      _PermissionService.permissions();
      _DashboardService.fetchBannerData();
      router.navigate([res?.redirect || '/products']);
      return true;
    } else {
      toater.showError(res?.message || 'Verification failed');
      router.navigate(['/login']);
      return false;
    }
  } catch (err: any) {
    toater.showError(err?.statusText || 'Error verifying token');
    router.navigate(['/login']);
    return false;
  }
};
